import { FormattedMessage } from '@edx/frontend-platform/i18n';
import messages from './messages';

const getDashboardMenu = () => {

  const MobileMenu = [
    {
      icon: 'home-2',
      text: <FormattedMessage {...messages.home} />,
      href: '/',
    },
    {
      icon: 'search',
      text: <FormattedMessage {...messages.discover} />,
      href: '/discover',
    },
    {
      icon: 'lightbulb',
      text: <FormattedMessage {...messages.myLearning} />,
      href: '/learning',
    },
  ];

  return { MobileMenu };
};

export default getDashboardMenu;